"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineFind = void 0;
var timeline_1 = require("../models/milestone/timeline");
var TimelineFind = /** @class */ (function () {
    function TimelineFind() {
    }
    TimelineFind.findById = function (nodes, id) {
        return nodes.findIndex(function (node) {
            var index = node.elements.findIndex(function (element) {
                return element.instance.id === id;
            });
            return index > -1;
        });
    };
    TimelineFind.findByMilestone = function (nodes, milestone) {
        return this.findById(nodes, milestone.id);
    };
    TimelineFind.findByProgress = function (nodes, progress) {
        return this.findById(nodes, progress.milestone || progress.id);
    };
    TimelineFind.findByElement = function (nodes, element) {
        return this.findById(nodes, element.instance.id);
    };
    TimelineFind.findByTime = function (nodes, month, year) {
        if (year === void 0) { year = new Date().getFullYear(); }
        var monthText = timeline_1.TimelineNode.month(month);
        return nodes.findIndex(function (node) {
            return node.month === monthText && node.year === year;
        });
    };
    TimelineFind.findToday = function (nodes) {
        var today = new Date();
        return nodes.findIndex(function (node) {
            return node.month === timeline_1.TimelineNode.month(today.getMonth()) && node.year === today.getFullYear();
        });
    };
    return TimelineFind;
}());
exports.TimelineFind = TimelineFind;
